'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pattern = exports.LinearGradient = undefined;

var _LinearGradient = require('./LinearGradient');

var _LinearGradient2 = _interopRequireDefault(_LinearGradient);

var _Pattern = require('./Pattern');

var _Pattern2 = _interopRequireDefault(_Pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Axis from './Axis';
// import AxisBottom from './AxisBottom';
// import AxisLeft from './AxisLeft';
// import AxisRight from './AxisRight';
// import AxisTop from './AxisTop';
exports.LinearGradient = _LinearGradient2.default;
exports.Pattern = _Pattern2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@potion/extra/lib/index.js
// module id = 219
// module chunks = 257593722917106